module.exports = __webpack_public_path__ + "static/media/oneDrive.84b471f5.jpg";